<template>
  <div>
    <div class="common-side-wrap">
      <div class="side-menu-wrap">
        <h3>帮助中心</h3>
        <ul>
          <li>
            <div>
              <i class="el-icon-user"></i>
              <a title="个人中心">个人中心</a>
            </div>
            <ul class="side-sub-menu-wrap">
              <li>
                <router-link :to="{path:'/Help'}" title="如何注册" :class="leftNavis==1?'menu-item-focus':'menu-item'">如何注册</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Agreement'}" title="用户协议" :class="leftNavis==2?'menu-item-focus':'menu-item'">用户协议</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Privacy'}" title="隐私申明" :class="leftNavis==3?'menu-item-focus':'menu-item'">隐私申明</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Password'}" title="忘记密码" :class="leftNavis==4?'menu-item-focus':'menu-item'">忘记密码</router-link>
              </li>
            </ul>
          </li>
          <li>
            <div>
              <i class="el-icon-setting"></i>
              <a title="新手指南">新手指南</a>
            </div>
            <ul class="side-sub-menu-wrap">
              <li>
                <router-link :to="{path:'/Placeorder'}" title="如何下单" :class="leftNavis==5?'menu-item-focus':'menu-item'">如何下单</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Howinqu'}" title="如何询价" :class="leftNavis==6?'menu-item-focus':'menu-item'">如何询价</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Howpay'}" title="如何支付" :class="leftNavis==7?'menu-item-focus':'menu-item'">如何支付</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Orderprogress'}" title="如何查看订单进度" :class="leftNavis==8?'menu-item-focus':'menu-item'">如何查看订单进度</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Exportprint'}" title="如何导出或打印订单" :class="leftNavis==9?'menu-item-focus':'menu-item'">如何导出或打印订单</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Pricedesc'}" title="价格说明" :class="leftNavis==10?'menu-item-focus':'menu-item'">价格说明</router-link>
              </li>
            </ul>
          </li>
          <li>
            <div>
              <i class="el-icon-truck"></i>
              <a title="配送政策">配送政策</a>
            </div>
            <ul class="side-sub-menu-wrap">
              <li>
                <router-link :to="{path:'/Freight'}" title="运费政策" :class="leftNavis==11?'menu-item-focus':'menu-item'">运费政策</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Shiptime'}" title="发货交期说明" :class="leftNavis==12?'menu-item-focus':'menu-item'">发货交期说明</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Inspection'}" title="验货" :class="leftNavis==13?'menu-item-focus':'menu-item'">验货</router-link>
              </li>
            </ul>
          </li>
          <li>
            <div>
              <i class="el-icon-service"></i>
              <a title="售后服务">售后服务</a>
            </div>
            <ul class="side-sub-menu-wrap">
              <li>
                <router-link :to="{path:'/Returngoods'}" title="退换货" :class="leftNavis==14?'menu-item-focus':'menu-item'">退换货</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Complaint'}" title="投诉与建议" :class="leftNavis==15?'menu-item-focus':'menu-item'">投诉与建议</router-link>
              </li>
            </ul>
          </li>
          <li>
            <div>
              <i class="el-icon-document-copy"></i>
              <a title="常见问题">常见问题</a>
            </div>
            <ul class="side-sub-menu-wrap">
              <!-- <li>
                <router-link :to="{path:'/Bill'}" title="发票管理" :class="leftNavis==16?'menu-item-focus':'menu-item'">发票管理</router-link>
              </li> -->
              <li>
                <router-link :to="{path:'/Addressmanag'}" title="地址管理" :class="leftNavis==17?'menu-item-focus':'menu-item'">地址管理</router-link>
              </li>
            </ul>
          </li>
          <li>
            <div>
              <i class="el-icon-warning-outline"></i>
              <a title="关于我们">关于我们</a>
            </div>
            <ul class="side-sub-menu-wrap">
              <li>
                <router-link :to="{path:'/About'}" title="公司简介" class="menu-item">公司简介</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Contactus'}" title="联系我们" :class="leftNavis==18?'menu-item-focus':'menu-item'">联系我们</router-link>
              </li>
              <li>
                <router-link :to="{path:'/Supplier'}" title="加入我们" class="menu-item">加入我们</router-link>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'LeftNavs',
  data () {
    return {
      // leftNavi: localStorage.getItem('leftNavi')
    }
  },
  props: ['leftNavis'],
  computed: {
    ...mapGetters(['current_user'])
  },
  mounted () {
  }
}
</script>
<style scoped>
.common-side-wrap {
  float: left;
}
.side-menu-wrap {
  background-color: #fff;
  width: 230px;
  border: 1px solid #e2e2e2;
  font-size: 12px;
  font-weight: 400;
  color: #666;
}
.side-menu-wrap > h3 {
  padding: 0 35px;
  border-bottom: 1px solid #e2e2e2;
  text-align: center;
  font-size: 16px;
  line-height: 40px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 700;
  color: #333;
}
.side-menu-wrap > ul {
  padding-bottom: 20px;
}
.side-menu-wrap > ul > li {
  text-align: left;
  padding-top: 10px;
  min-height: 34px;
  line-height: 34px;
}
.side-menu-wrap > ul > li > div {
  padding: 0 86px;
  height: 34px;
  position: relative;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 700;
}
.side-menu-wrap > ul > li > div > i {
  position: absolute;
  display: block;
  left: 63px;
  color: #8a8a8a;
  top: 8px;
  bottom: 0;
  margin: auto;
  font-size: 16px;
}
.iconfont {
  font-family: iconfont!important;
  padding-left: 4px;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -webkit-text-stroke-width: 0.2px;
  -moz-osx-font-smoothing: grayscale;
}
.side-menu-wrap > ul > li a {
  display: inline-block;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #666;
  cursor: default;
}
.side-menu-wrap > ul > li > ul.side-sub-menu-wrap {
  display: block;
  padding: 0 35px 0 86px;
  line-height: 32px;
  background-color: #fff;
}
.side-menu-wrap > ul > li > ul.side-sub-menu-wrap > li {
  position: relative;
  height: 32px;
}
.side-menu-wrap > ul > li a.menu-item {
  cursor: pointer;
}
.side-menu-wrap > ul > li a.menu-item-focus, .side-menu-wrap > ul > li a.menu-item.active, .side-menu-wrap > ul >li a.menu-item:hover {
  color: #e50014;
}
</style>



// WEBPACK FOOTER //
// src/components/Help/Left_navs.vue